import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./Header.css";
import SocialIcons from "./SocialIcons";

function Header({ schema }) {
    // Menü Funktion START

    const [menuVisible, setMenuVisible] = useState(false);

    useEffect(() => {
        // console.log("menuVisible " + menuVisible);
        if (menuVisible) {
            document.querySelector(".Header__menu").style.transform = "scale(1)";
            document.querySelector(".menu__side").style.transform = "translateX(0)";
        } else {
            document.querySelector(".menu__side").style.transform = "translateX(100%)";
            document.querySelector(".Header__menu").style.transform = "scale(0)";
        }
    }, [menuVisible]);

    // Menü Funktion ENDE

    // Logo / Header scroll animation
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 150) {
                document.querySelector(".logo__svg").classList.add("small");
                document.querySelector(".logo__path2").classList.add("hidden");
                document.querySelector(".Header").classList.add("scroll");
            } else {
                document.querySelector(".logo__svg").classList.remove("small");
                document.querySelector(".logo__path2").classList.remove("hidden");
                document.querySelector(".Header").classList.remove("scroll");
            }
        });
    }, []);

    useEffect(() => {
        const header = document.querySelector(".Header");
        document.documentElement.style.setProperty("--header-height", header.offsetHeight - 5 + "px");
    }, []);

    return (
        <header className={"Header " + schema}>
            <a href="/" className="Header__logo" title="zur Startseite">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455 408" className={"logo__svg " + schema}>
                    <g>
                        <path d="M331.78,.01c-69.85-.97-126.78,55.36-126.78,124.99v1l-.02-.02c-.55,45.18-38.72,81.48-84.58,78.89-40.45-2.28-73.11-35.04-75.28-75.49-2.47-46.09,34.32-84.38,79.88-84.38,18.75,0,36,6.5,49.66,17.34l31.99-31.99C184.77,11.46,156.26,.02,125.09,0,57.05-.05,1,55.12,.01,123.15c-1.01,69.88,55.34,126.85,124.99,126.85,30.44,0,58.32-10.9,80-28.98v141.98c0,24.85,20.15,45,45,45h0V221.04c21.68,18.08,49.57,28.96,80,28.96,69.63,0,125.96-56.93,124.99-126.78C454.05,55.9,399.11,.95,331.78,.01Zm-1.78,204.99c-44.11,0-80-35.89-80-80s35.89-80,80-80,80,35.89,80,80-35.89,80-80,80Z" />
                        <path
                            className="logo__path2"
                            d="M310.84,377.08c-3.02,0-5.38,1.11-7.07,3.33-1.69,2.22-2.53,5.29-2.53,9.2v5.51c.06,3.83,.95,6.8,2.66,8.9,1.71,2.1,4.03,3.15,6.98,3.15s5.42-1.08,7.09-3.24,2.49-5.24,2.49-9.23v-5.33c-.04-3.94-.9-6.97-2.58-9.1-1.68-2.12-4.03-3.19-7.04-3.19Zm6.03,17.98c-.04,2.99-.54,5.21-1.51,6.66-.97,1.45-2.46,2.17-4.48,2.17s-3.53-.78-4.54-2.35c-1.01-1.57-1.52-3.85-1.52-6.84v-5.25c.01-2.98,.53-5.23,1.54-6.76,1.01-1.53,2.51-2.29,4.49-2.29s3.56,.75,4.54,2.26c.99,1.51,1.48,3.81,1.48,6.91v5.49Zm-4.79-86.73c3.06,0,5.42-1.08,7.09-3.24s2.49-5.24,2.49-9.23v-5.33c-.04-3.94-.9-6.97-2.58-9.1-1.68-2.12-4.03-3.19-7.04-3.19s-5.38,1.11-7.07,3.33c-1.69,2.22-2.53,5.29-2.53,9.2v5.51c.06,3.83,.95,6.8,2.66,8.9,1.71,2.1,4.03,3.15,6.98,3.15Zm-6.07-17.71c.01-2.98,.53-5.23,1.54-6.76,1.01-1.53,2.51-2.29,4.49-2.29s3.56,.75,4.54,2.26c.99,1.51,1.48,3.81,1.48,6.91v5.49c-.04,2.99-.54,5.21-1.51,6.66-.97,1.45-2.46,2.17-4.48,2.17s-3.53-.78-4.54-2.35c-1.01-1.57-1.52-3.85-1.52-6.84v-5.25Zm-3.98,66.73h3.59v-29.28h-3.59v29.28Zm-19.47,49.42h3.59v-12.93h9.66v-3.16h-9.66v-10.03h11.29v-3.16h-14.88v29.28Zm7.44-113.41l-5.85-14.7h-4.08l8.13,18.36v10.92h3.59v-10.92l8.13-18.36h-4.06l-5.85,14.7Zm-7.44,64h3.59v-12.93h9.66v-3.16h-9.66v-10.03h11.29v-3.16h-14.88v29.28Zm124.23-16.43c-1.81-.66-3.14-1.4-4-2.24-.86-.83-1.3-1.87-1.3-3.1,0-1.5,.4-2.67,1.2-3.5s1.92-1.25,3.38-1.25c1.6,0,2.82,.5,3.67,1.49s1.28,2.39,1.28,4.2h3.61c0-1.63-.35-3.14-1.06-4.5s-1.71-2.43-3.02-3.2-2.8-1.15-4.48-1.15c-2.45,0-4.43,.75-5.94,2.25-1.51,1.5-2.27,3.41-2.27,5.73,0,1.34,.27,2.53,.79,3.57,.53,1.04,1.33,1.96,2.4,2.77,1.07,.81,2.61,1.59,4.62,2.32,2.02,.74,3.41,1.5,4.18,2.27,.77,.78,1.16,1.9,1.16,3.36s-.4,2.57-1.2,3.4c-.8,.83-1.99,1.25-3.57,1.25-1.7,0-3.05-.5-4.03-1.51-.99-1.01-1.48-2.41-1.48-4.22h-3.61c0,1.74,.4,3.29,1.21,4.63,.8,1.35,1.91,2.39,3.32,3.14,1.41,.74,2.94,1.12,4.6,1.12,2.59,0,4.64-.71,6.14-2.14s2.26-3.33,2.26-5.7-.61-4.08-1.82-5.47c-1.21-1.39-3.22-2.57-6.04-3.52Zm-49.82,36.57h-6.81v29.28h6.4c3.56,0,6.27-1.06,8.15-3.17,1.87-2.11,2.81-5.1,2.81-8.98v-4.91c0-3.87-.92-6.88-2.77-9.02-1.85-2.14-4.44-3.21-7.77-3.21Zm6.99,17.31c-.03,2.91-.62,5.11-1.79,6.59-1.16,1.48-3.01,2.22-5.54,2.22h-2.89v-22.96h3.22c2.34,0,4.09,.72,5.25,2.16,1.16,1.44,1.74,3.71,1.74,6.79v5.19Zm-2.63-50.98h10.11v-3.16h-10.11v-9.43h11.58v-3.16h-15.17v29.28h15.37v-3.16h-11.78v-10.38Zm24.64-2.9c-1.81-.66-3.14-1.4-4-2.24-.86-.83-1.3-1.87-1.3-3.1,0-1.5,.4-2.67,1.2-3.5s1.92-1.25,3.38-1.25c1.6,0,2.82,.5,3.67,1.49s1.28,2.39,1.28,4.2h3.61c0-1.63-.35-3.14-1.06-4.5s-1.71-2.43-3.02-3.2-2.8-1.15-4.48-1.15c-2.45,0-4.43,.75-5.94,2.25-1.51,1.5-2.27,3.41-2.27,5.73,0,1.34,.27,2.53,.79,3.57,.53,1.04,1.33,1.96,2.4,2.77,1.07,.81,2.61,1.59,4.62,2.32,2.02,.74,3.41,1.5,4.18,2.27,.77,.78,1.16,1.9,1.16,3.36s-.4,2.57-1.2,3.4c-.8,.83-1.99,1.25-3.57,1.25-1.7,0-3.05-.5-4.03-1.51-.99-1.01-1.48-2.41-1.48-4.22h-3.61c0,1.74,.4,3.29,1.21,4.63,.8,1.35,1.91,2.39,3.32,3.14,1.41,.74,2.94,1.12,4.6,1.12,2.59,0,4.64-.71,6.14-2.14s2.26-3.33,2.26-5.7-.61-4.08-1.82-5.47c-1.21-1.39-3.22-2.57-6.04-3.52h0Zm-31.33-40.65h9.66l2.26,7.66h3.69l-9.23-29.28h-3.08l-9.21,29.28h3.69l2.22-7.66Zm4.83-16.47l3.91,13.31h-7.79l3.89-13.31Zm-27.79-.33c.96-1.37,2.46-2.06,4.51-2.06,1.71,0,2.99,.51,3.84,1.54,.84,1.03,1.34,2.45,1.48,4.27h3.59c-.16-2.88-1-5.1-2.54-6.65-1.54-1.55-3.67-2.32-6.39-2.32-3.19,0-5.59,1.02-7.19,3.07-1.6,2.04-2.41,5.12-2.41,9.22v5.75c.04,3.83,.94,6.8,2.7,8.9,1.76,2.1,4.18,3.15,7.27,3.15,3.48,0,6.12-1.08,7.93-3.24l.63-.8v-10.94h-8.81v3.16h5.22v6.72l-.53,.5c-1.01,.96-2.48,1.44-4.42,1.44-2.05,0-3.63-.79-4.73-2.36-1.1-1.58-1.65-3.84-1.65-6.79v-5.97c.04-3.02,.54-5.21,1.49-6.58Zm19.84,44.6h-3.57v22.66l-11.48-22.66h-3.61v29.28h3.61v-22.56l11.44,22.56h3.61v-29.28Zm-22.89,0h-18.61v3.16h7.5v26.12h3.59v-26.12h7.52v-3.16Zm6.36,49.01c-3.02,0-5.38,1.11-7.07,3.33-1.69,2.22-2.53,5.29-2.53,9.2v5.51c.06,3.83,.95,6.8,2.66,8.9,1.71,2.1,4.03,3.15,6.98,3.15s5.42-1.08,7.09-3.24,2.49-5.24,2.49-9.23v-5.33c-.04-3.94-.9-6.97-2.58-9.1-1.68-2.12-4.03-3.19-7.04-3.19Zm6.03,17.98c-.04,2.99-.54,5.21-1.51,6.66-.97,1.45-2.46,2.17-4.48,2.17s-3.53-.78-4.54-2.35c-1.01-1.57-1.52-3.85-1.52-6.84v-5.25c.01-2.98,.53-5.23,1.54-6.76,1.01-1.53,2.51-2.29,4.49-2.29s3.56,.75,4.54,2.26c.99,1.51,1.48,3.81,1.48,6.91v5.49Z"
                        />
                    </g>
                </svg>
            </a>
            <nav className={"Header__links " + schema}>
                <Link to="/ueber-mich" title="Über mich">
                    Über mich
                </Link>
                <HashLink to={"/"} elementId={"b2"} title="Leistungen">
                    Leistungen
                </HashLink>
                <div className={"links__dropDown " + schema}>
                    <span
                        className={"dropDown__titel"}
                        onClick={(e) => {
                            document.querySelector(".dropDown__titel").classList.toggle("open");
                            document.querySelector(".Header").classList.toggle("dropOpen");
                        }}
                    >
                        Preise
                        <div className="dropDown__items">
                            <HashLink to={"/yoga"} elementId={"b5"} title="Preise zu Yoga">
                                -&nbsp;Yoga
                            </HashLink>
                            <HashLink to={"/fitness"} elementId={"b6"} title="Preise zu Fitness">
                                -&nbsp;Fitness
                            </HashLink>
                            <HashLink to={"/stand-up-paddling-in-saalburg"} elementId={"b5"} title="Preise zu Stand Up Paddling">
                                -&nbsp;SUP
                            </HashLink>
                        </div>
                    </span>
                </div>
                <Link to="/kurskalender" title="Kurskalender">
                    Kurskalender
                </Link>
                <Link to="/blog" title="News & Termine">
                    News & Termine
                </Link>
            </nav>
            <div className={"Header__menuBtn " + schema} onClick={() => setMenuVisible(true)}>
                <i className="bi bi-list"></i>
            </div>
            <nav className="Header__menu">
                <div className="menu__side">
                    <img src="/img/icons/close_white.svg" className="side__close" alt="Menü schliessen" onClick={() => setMenuVisible(false)} />
                    <Link to={"/ueber-mich"} title="Über mich" onClick={() => setMenuVisible(false)}>
                        Über mich
                    </Link>
                    <HashLink to={"/"} elementId={"b2"} title="Leistungen" onClick={() => setMenuVisible(false)}>
                        Leistungen
                    </HashLink>
                    <div className="side__dropdown">
                        <span
                            className={"dropdown__titel"}
                            onClick={(e) => {
                                e.target.classList.toggle("open");
                            }}
                        >
                            Preise
                            <div className="dropdown__list">
                                <HashLink to={"/yoga"} elementId={"b5"} title="zu Yoga" className="d-block ps-3 fs-3" onClick={() => setMenuVisible(false)}>
                                    -&nbsp;Yoga
                                </HashLink>
                                <HashLink to={"/fitness"} elementId={"b8"} title="zu Fitness" className="d-block ps-3 fs-3" onClick={() => setMenuVisible(false)}>
                                    -&nbsp;Fitness
                                </HashLink>
                                <HashLink to={"/stand-up-paddling-in-saalburg"} elementId={"b5"} title="zu Stand Up Paddling" className="d-block ps-3 fs-3" onClick={() => setMenuVisible(false)}>
                                    -&nbsp;SUP
                                </HashLink>
                            </div>
                        </span>
                    </div>
                    <Link to="/kurskalender" title="Kurskalender">
                        Kurskalender
                    </Link>
                    <Link to={"/blog"} title="News & Termine" onClick={() => setMenuVisible(false)}>
                        News & Termine
                    </Link>
                    <Link to={"/aktivurlaub"} title="Aktivurlaub" onClick={() => setMenuVisible(false)}>
                        Aktivurlaub
                    </Link>
                    <HashLink to={"#newsletter"} title="Newsletter" onClick={() => setMenuVisible(false)}>
                        Newsletter
                    </HashLink>
                    <Link to={"/yoga"} title="Yoga" className={"color-secondary"} onClick={() => setMenuVisible(false)}>
                        Yoga
                    </Link>
                    <Link to={"/fitness"} title="Fitness" className={"color-secondary"} onClick={() => setMenuVisible(false)}>
                        Fitness
                    </Link>
                    <Link to={"/firmenfitness"} title="BGM / Firmenfitness" className={"color-secondary"} onClick={() => setMenuVisible(false)}>
                        BGM / Firmenfitness
                    </Link>
                    <Link to={"/ernaehrungscoaching"} title="Ernährungcoaching" className={"color-secondary"} onClick={() => setMenuVisible(false)}>
                        Ernährung&shy;coaching
                    </Link>
                    <Link to={"/stand-up-paddling-in-saalburg"} title="Stand Up Paddling" className={"color-secondary"} onClick={() => setMenuVisible(false)}>
                        Stand Up Paddling
                    </Link>
                    <SocialIcons />
                </div>
                <div className="menu__background" onClick={() => setMenuVisible(false)}></div>
            </nav>
            <div className="Header__bg"></div>
        </header>
    );
}

export default Header;
